import React, { useRef, createRef } from 'react';
import { DetailAccountInfo } from './Types';
import { TouchLink, TouchLinkGroup } from '@amzn/storm-ui';
import styled from 'styled-components';
import { AccountListItem } from './AccountListItem';

const AccountTouchLinkGroup = styled(TouchLinkGroup)`
  && > li > a {
    text-decoration: none;
  }
`;

type AccountListMobileProps = {
  accounts: DetailAccountInfo[];
  handleClick: (detailedAccount: DetailAccountInfo, index: number,
    elementsRef: React.MutableRefObject<React.RefObject<HTMLElement>[]>) => void;
};

export const AccountListMobile: React.VFC<AccountListMobileProps> =
  ({accounts, handleClick}) => {
  const elementsRef = useRef(accounts.map(() => createRef<HTMLElement>()));

  return (
    <AccountTouchLinkGroup>
      {accounts.map((account, index) => {
          return (
            <div
              data-testid={account.url}
              key={account.entityId}
              onClick={() => handleClick(account, index, elementsRef)}
              ref={elementsRef.current[index] as React.RefObject<HTMLDivElement>}
              data-takt-id={`interstitial-account-${account.entityId}-mobile`}
            >
              <TouchLink key={account.entityId} href="#">
                  <AccountListItem key={account.entityId} label={account.label} entityId={account.entityId}
                                   accountHasNestedAccounts={account.nestedAccounts ? account.nestedAccounts.length > 0 : false}/>
              </TouchLink>
            </div>
          );
      })}
    </AccountTouchLinkGroup>
  );
}